<main>
  <loading-overlay [isLoading]="isLoading > 0" />
  <header>
    <div class="headline">
      <h1>
        {{ 'Invoice_Details_Title' | translateWF: 'Invoice' }}:
        {{ invoice ? invoice.invoiceNumber : ('Invoice_Details_Title_New' | translateWF: 'New Invoice') }}
      </h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="invoicePurchaseOrderStatusOptions"></csl-dropdown>
    </div>
    <div class="buttons">
      <p-button
        *ngIf="invoice ? invoice.status != 2 : true"
        [label]="'Save' | translateWF: 'Save'"
        (click)="save()"
        [disabled]="invalidQuantities || !canEdit() || listPurchaseOrderSelected().length <= 0"
      />
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <form [formGroup]="invoiceForm" class="col">
      <p-panel [header]="'Invoice_Details_General_Information' | translateWF: 'General Information'">
        <p-card>
          <div class="grid-auto-2">
            <div class="form-box">
              <label for="">{{ 'Invoice_Details_Provider_Invoice_Number' | translateWF: 'Provider Invoice Number' }}</label>
              <input type="text" class="p-inputtext p-component w-full" [formControl]="providerInvoiceNumber" />
            </div>
            <div class="form-box">
              <label for="issuedDate">{{ 'Invoice_Details_Issued_Date' | translateWF: 'Issued Date' }}</label>

              <p-calendar
                fluid=""
                class="w-full"
                inputId="issuedDate"
                formControlName="issuedDate"
                [showIcon]="false"
                dateFormat="yy-mm-dd"
                appendTo="body"
                [ngClass]="{ 'ng-invalid ng-dirty': inputIssuedDate.invalid && inputIssuedDate.touched }"
              >
              </p-calendar>
            </div>
            <div class="form-box">
              <label for="dueDate">{{ 'Invoice_Details_Due_Date' | translateWF: 'Due Date' }}</label>
              <p-calendar fluid="" class="w-full" inputId="dueDate" formControlName="dueDate" [showIcon]="false" dateFormat="yy-mm-dd" appendTo="body"> </p-calendar>
            </div>
            <div class="col mb-2" *ngIf="getCurrentCurrency() !== 0">
              <div class="form-box">
                <label for="dueDate">{{ 'Invoice_Details_Exchange_Rate' | translateWF: 'Exchange Rate' }}</label>
                <p-inputgroup>
                  <p-inputGroupAddon>USD</p-inputGroupAddon>
                  <p-inputnumber formControlName="exchangeRate" minFractionDigits="2" maxFractionDigits="2" />
                </p-inputgroup>
              </div>
              <div class="row-start-center">
                <p-checkbox inputId="differentExchangeRate" [binary]="true" [formControl]="differentExchangeRate" />
                <label for="differentExchangeRate" class="ml-2 mt-2">
                  {{ 'Invoice_Details_Different_Exchange_Rate' | translateWF: 'Different Exchange Rate' }}
                </label>
              </div>
            </div>
          </div>
        </p-card>
      </p-panel>

      <p-panel [header]="'InvoiceDetails.PurchaseOrderRelated' | translateWF: 'Purchase Order Related'">
        <ng-template pTemplate="icons">
          <p-autocomplete
            fluid=""
            class="w-full"
            formControlName="purchaseOrder"
            [dropdown]="true"
            [suggestions]="purchaseOrdersToDisplay"
            optionLabel="purchaseOrderNumber"
            (completeMethod)="searchPurchaseOrder($event)"
            (onSelect)="addPurchaseOrderAtList($event)"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listPurchaseOrderSelected()">
            <ng-template #header>
              <tr>
                <th>{{ 'InvoiceDetails.TablePurchaseOrderNumber' | translateWF: 'Purchase Order Number' }}</th>
                <th>{{ 'InvoiceDetails.TableProvider' | translateWF: 'Provider' }}</th>
                <th>{{ 'InvoiceDetails.TableQuantity' | translateWF: 'Quantity' }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-PO let-index="rowIndex">
              <tr class="text-center">
                <td>
                  {{ PO.purchaseOrderNumber }}
                </td>
                <td>
                  {{ PO.provider?.name || 'N/A' }}
                </td>
                <td>
                  {{ PO.items[0].quantity | number: '1.0-0' }}
                </td>
                <td>
                  <p-button icon="pi pi-trash" variant="text" (click)="deletePurchaseOrderAtList(index)" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>

      @if (listPurchaseOrderSelected().length > 0) {
        @if (listPurchaseOrderSelected()[0].type > 0) {
          <p-panel [header]="'Manufacturer' | translateWF: 'Manufacturer'">
            <p-card>
              <div class="span-6 pl-2">
                <div class="row-start-center mb-2">
                  <p-checkbox inputId="manufacturerAllItems" [binary]="true" [formControl]="manufacturerAllItems"> </p-checkbox>
                  <label for="manufacturerAllItems" class="ml-2 mt-2">
                    {{ 'Apply_Manufactures_All_Items' | translateWF: 'Same manufacturer for all items' }}
                  </label>
                </div>
                <div class="form-box">
                  <label for="">{{ 'Manufacturer' | translateWF: 'Manufacturer' }}</label>
                  <p-autocomplete
                    fluid=""
                    class="w-full"
                    [formControl]="inputMaker"
                    [dropdown]="true"
                    [suggestions]="providersToDisplay"
                    optionLabel="name"
                    (completeMethod)="searchProvider($event)"
                  />
                  <small id="makers" *ngIf="inputMaker.value?.code">{{ inputMaker.value!.code }}</small>
                </div>
              </div>
            </p-card>
          </p-panel>
        }
      }

      <p-panel [header]="'Purchase_Order_Details_Items' | translateWF: 'Items'">
        <p-card data-variant="compact">
          <p-table [value]="formArrayItems.controls">
            <ng-template #header>
              <tr>
                <th rowspan="6" style="width: 16rem">{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item' }}</th>
                <th>{{ 'InvoiceDetails.PurchaseOrder' | translateWF: 'Purchase Order' }}</th>
                @if (listPurchaseOrderSelected().length > 0) {
                  @if (listPurchaseOrderSelected()[0].type > 0) {
                    <th>{{ 'Manufacturer' | translateWF: 'Manufacturer' }}</th>
                  }
                }
                <th>{{ 'Purchase_Order_Details_Quantity' | translateWF: 'Quantity' }}</th>
                <th>{{ 'Purchase_Order_Details_Item_Price' | translateWF: 'Item Price' }}</th>
                <th>{{ 'Purchase_Order_Details_Total_Item_Price' | translateWF: 'Total Item Price' }}</th>
                @if (canEdit()) {
                  <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-index="rowIndex" formArrayName="items">
              <tr class="cursor-pointer" [formGroupName]="index">
                <td pTooltip="{{ localeHelperService.getLocalizedValue(item.get('itemDescription')?.value) }}" tooltipPosition="top">
                  <b>
                    {{ getItemMasterForPurchaseOrderItemId(item.get('itemCode')?.value)?.itemCode }}
                  </b>
                  <p>
                    {{ localeHelperService.getLocalizedValue(getItemMasterForPurchaseOrderItemId(item.get('itemCode')?.value)?.itemDescription) }}
                  </p>
                </td>
                <td>
                  <p-dropdown
                    fluid=""
                    class="w-full"
                    formControlName="selectedPurchaseOrder"
                    [options]="getAvailablePurchaseOrdersForItem(item.get('itemCode')?.value)"
                    optionLabel="purchaseOrderNumber"
                    placeholder="{{ 'InvoiceDetails.SelectPurchaseOrder' | translateWF: 'Select PO' }}"
                    [disabled]="!canEdit()"
                  >
                  </p-dropdown>
                </td>
                @if (listPurchaseOrderSelected().length > 0) {
                  @if (listPurchaseOrderSelected()[0].type > 0) {
                    <td>
                      <p-autocomplete
                        fluid=""
                        class="w-full"
                        formControlName="manufacturerReference"
                        [dropdown]="true"
                        [suggestions]="providersToDisplay"
                        optionLabel="name"
                        (completeMethod)="searchProviderForRow($event, index)"
                      >
                      </p-autocomplete>
                    </td>
                  }
                }

                <td>
                  <p-inputgroup>
                    <p-inputnumber
                      formControlName="quantity"
                      minFractionDigits="2"
                      maxFractionDigits="2"
                      [class.ng-invalid]="item.get('quantity').value <= 0"
                      [class.ng-dirty]="true"
                    />
                    <p-inputGroupAddon>
                      {{ uoms[getItemMasterForPurchaseOrderItemId(item.get('itemCode')?.value)?.unitOfMeasure ?? 0] }}
                    </p-inputGroupAddon>
                  </p-inputgroup>

                  <p *ngIf="item.get('quantity')?.hasError('quantityExceeded')" class="error">
                    {{ 'Invoice_Details_Quantity_Exceeded' | translateWF: 'Quantity exceeded limit' }}
                  </p>
                </td>
                <td>
                  <!-- Base Unit Price (Read-only, from PO) -->
                  <p-inputgroup>
                    <p-inputGroupAddon> {{ getCurrencySymbol() }} </p-inputGroupAddon>
                    <p-inputnumber formControlName="unitPrice" [disabled]="true" minFractionDigits="2" maxFractionDigits="6" />
                  </p-inputgroup>

                  <!-- Unit Price with Tax (Calculated, Read-only) - Only show if item has tax -->
                  <p-inputgroup class="mt-2" *ngIf="itemHasTax(item)">
                    <p-inputGroupAddon> {{ getCurrencySymbol() }} (incl. tax) </p-inputGroupAddon>
                    <p-inputnumber [ngModel]="getUnitPriceWithTax(item)" [ngModelOptions]="{ standalone: true }" [disabled]="true" minFractionDigits="2" maxFractionDigits="6" />
                  </p-inputgroup>
                </td>
                <td>
                  <p-inputgroup>
                    <p-inputGroupAddon> {{ getCurrencySymbol() }} </p-inputGroupAddon>
                    <p-inputnumber formControlName="totalPrice" [readonly]="true" minFractionDigits="2" maxFractionDigits="6" />
                  </p-inputgroup>
                </td>
                @if (canEdit()) {
                  <td>
                    <p-button icon="pi pi-trash" variant="text" (click)="deleteItemArrayForm(index); $event.stopPropagation()" />
                  </td>
                }
              </tr>
            </ng-template>

            <!-- inputPurchaseOrder.value?.items?.length > 0 -->
            <ng-template pTemplate="footer">
              @if (listPurchaseOrderSelected().length > 0) {
                <tr>
                  <td [attr.colspan]="itemsTableColumnCount">
                    <div>
                      <p-dropdown
                        [options]="purchaseOrderItems"
                        optionLabel="item.fieldToDisplay"
                        optionValue="itemCode"
                        [formControl]="itemSelected"
                        (onChange)="addItemIntoArrayForm($event.value)"
                        placeholder="{{ 'Invoice_Details_Select_Item' | translateWF: 'Select an item' }}"
                      >
                      </p-dropdown>
                    </div>
                  </td>
                </tr>
              }

              <tr>
                <td>
                  <p>{{ 'Invoice_Details_Total_Quantities' | translateWF: 'Total Quantities' }}</p>
                </td>
                <td>
                  <p-inputgroup>
                    <p-inputnumber [formControlName]="'totalQuantitiesLbs'" minFractionDigits="2" maxFractionDigits="2"></p-inputnumber>
                    <p-inputGroupAddon> Lbs </p-inputGroupAddon>
                  </p-inputgroup>
                  <br />
                  <p-inputgroup>
                    <p-inputnumber [formControlName]="'totalQuantitiesKgs'" minFractionDigits="2" maxFractionDigits="2" />
                    <p-inputGroupAddon> Kgs </p-inputGroupAddon>
                  </p-inputgroup>
                </td>
                <td [attr.colspan]="itemsTableColumnCount - 2"></td>
              </tr>
              <tr>
                <td [attr.colspan]="itemsTableColumnCount - 3"></td>
                <td>
                  <b>{{ 'Purchase_Order_Details_Total_Price' | translateWF: 'Total Price' }}</b>
                </td>
                <td colspan="2">
                  <p-inputgroup>
                    <p-inputGroupAddon> {{ getCurrencySymbol() }} </p-inputGroupAddon>
                    <p-inputnumber [formControlName]="'totalAmount1'" minFractionDigits="2" maxFractionDigits="2" />
                  </p-inputgroup>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>

      <p-panel [header]="'Purchase_Order_Details_Files' | translateWF: 'Files'">
        <p-card>
          @if (!invoice) {
            <p>{{ 'Invoice_Details_To_Upload_Files' | translateWF: 'To upload files, save invoice first.' }}</p>
          } @else {
            <div class="files-content">
              @if (canEdit()) {
                <!-- <div class="drag-and-drop">
                  <p>
                    <b>{{ 'Purchase_Order_Details_Drag_And_Drop' | translateWF: 'Drag and drop' }}</b>
                  </p>
                  <p>{{ 'Purchase_Order_Details_Or' | translateWF: 'or' }}</p>
                  <input type="file" class="hidden" accept="*/*" #file (change)="onFileSelected($event)" />
                  <p-button
                    [label]="'Purchase_Order_Details_Browse_File' | translateWF: 'Browse File'"
                    icon="pi pi-download"
                    variant="outlined"
                    (click)="file.click()"
                  />
                </div> -->

                <div class="drag-and-drop">
                  <ngx-file-drop [showBrowseBtn]="false" (onFileDrop)="uploadFiles($event)">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <div class="drop-content">
                        <p class="title">
                          <b>{{ 'Purchase_Order_Details_Drag_And_Drop' | translateWF: 'Drag and drop' }}</b>
                        </p>
                        <p class="or-text">{{ 'Purchase_Order_Details_Or' | translateWF: 'or' }}</p>
                        <p-button
                          [label]="'Purchase_Order_Details_Browse_File' | translateWF: 'Browse File'"
                          icon="pi pi-download"
                          variant="outlined"
                          (onClick)="openFileSelector()"
                        ></p-button>
                      </div>
                    </ng-template>
                  </ngx-file-drop>
                </div>
              }
              <div class="uploaded-files">
                <div class="under__line">
                  <h4>{{ 'Purchase_Order_Details_Uploaded' | translateWF: 'Uploaded' }}</h4>
                </div>
                <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
                  <ul>
                    @for (file of this.invoice.files; track $index) {
                      <li class="mb-5">
                        <div class="info">
                          <p class="type">
                            <b>{{ file.name.split('.').pop() }}</b>
                          </p>
                          <a (click)="viewFile(file.presignedUrl)" class="file-name">{{ getFileName(file.name) }}</a>
                        </div>
                        @if (canEdit()) {
                          <div class="actions">
                            <p-button icon="pi pi-trash" variant="text" (onClick)="deleteFile(file)" />
                          </div>
                        }
                      </li>
                    } @empty {
                      <li>
                        <p>{{ 'Purchase_Order_Details_No_Files_Uploaded' | translateWF: 'No files uploaded' }}</p>
                      </li>
                    }
                  </ul>
                </p-scrollpanel>
              </div>
            </div>
          }
        </p-card>
      </p-panel>
    </form>
  </div>

  <p-confirmDialog key="invoice-status-confirm" />
</main>
